// extracted by mini-css-extract-plugin
export default {"NavItemVerticalMini":"NavItemVerticalMini_NavItemVerticalMini__-5uOR","Label":"NavItemVerticalMini_Label__qBUG1","isCollapsed":"NavItemVerticalMini_isCollapsed__hpNFG"};